import { useQuery } from 'react-query';

export enum AirportMarketFilter {
  ALL = 'ALL',
  ORIGIN = 'ORIGIN',
  DESTINATION = 'DESTINATION',
  NONE = 'NONE'
}

export type Airport = {
  label: string;
  value: string;
  locationId?: string;
  zoneId?: string;
  city?: $TSFixMe;
  extraInfo?: $TSFixMe;
};

type AirportOptions = {
  airportType?: 'ORIGIN' | 'DESTINATION';
  selectedOrigin?: string;
  filterByMarket: AirportMarketFilter;
};

export type FetchAirports = (options: AirportOptions) => Promise<Airport[]>;

export function useAirports(fetchAirports: FetchAirports, options: AirportOptions) {
  const key =
    options.airportType === 'ORIGIN' ? 'origins' : `destinations-${options.selectedOrigin ?? ''}`;
  return useQuery(key, () => fetchAirports(options), {
    refetchOnWindowFocus: false,
    staleTime: 86400000
  });
}
